CatalogsListController.$inject = ['CatalogService'];
export default function CatalogsListController(CatalogService) {
    var ctrl = this;
    ctrl.load = load;

    ctrl.$onInit = function() {
        load();
    };

    ////////

    function load() {
        CatalogService.get().$promise.then(function(response) {
            ctrl.content = response;
        });
    }
}
